export default __webpack_public_path__ + "423407ea990446d51dbb88136a46391b.svg";